__turbopack_context__.v({
  "className": "rubik_a051d689-module__cpDQuq__className",
});
